import React, { Component } from "react";
import I18n from "i18n-js";

import useRoutingState from "../hooks/useRoutingState";

import ComingSoon from "../commons/ComingSoon";

const DataLab = () => {
  useRoutingState();

  return (
    <div className="data-lab">
      <div className="container-fluid">
        <ComingSoon
          title={I18n.t("data_lab.features.title")}
          features={[
            I18n.t("data_lab.features.first"),
            I18n.t("data_lab.features.second"),
            I18n.t("data_lab.features.third")
          ]}
        />
      </div>
    </div>
  );
}

// NOTE: needed now to current version of ReactOnRails to work with hooks
export default class DataLabComponent extends Component {
  render() {
    return <DataLab {...this.props} />;
  }
}
